import { useEffect } from 'react';
import { useRestaurant } from '../contexts/RestaurantContext';
import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook to dynamically update the page title based on:
 * - Restaurant name from settings
 * - User role
 * - Current page name
 * 
 * Format: "{Restaurant Name} - {Role} - {Page}"
 * Example: "Qrypt - Admin - Dashboard"
 */
export function usePageTitle(pageName: string) {
  const { restaurantName } = useRestaurant();
  const { user } = useAuth();

  useEffect(() => {
    if (restaurantName && user?.role) {
      const roleCapitalized = user.role.charAt(0).toUpperCase() + user.role.slice(1);
      document.title = `${restaurantName} - ${roleCapitalized} - ${pageName}`;
    } else {
      document.title = `${pageName} - QryptApps Dashboard`;
    }
  }, [restaurantName, user?.role, pageName]);
}
